import Body from './components/Body.js';
import Header from './components/Header.js'
// import dotenv from 'dotenv';

// dotenv.config();

function App() {
  return (
    <div className="App">
      <Header />
      <Body />
    </div>
  );
}

export default App;
